import { render, staticRenderFns } from "./GoalTrackingTag.vue?vue&type=template&id=9c6c3b04&scoped=true&"
import script from "./GoalTrackingTag.vue?vue&type=script&lang=ts&"
export * from "./GoalTrackingTag.vue?vue&type=script&lang=ts&"
import style0 from "./GoalTrackingTag.vue?vue&type=style&index=0&id=9c6c3b04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c6c3b04",
  null
  
)

export default component.exports